import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  Stack,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { useQuery } from "@apollo/client";
//Icons
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
//Srcs
import "../../Style/dialogstyle.scss";
import EmptyImge from "../../Assets/empty-image.png";
import { SELECT_MATERIAL } from "../../Schema/Material";
import { SELECT_UNIT_BYID_MATERIAL } from "../../Schema/Reqpurchase";

export default function ListBook({
  handleUpdateList,
  handleDeleteList,
  handleAddList,
  requiredField,
  bookList,
  groupId,
}) {
  const [listMaterialOptions, setMeterialOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);

  const [materialId, setMaterialId] = useState("");
  const [checkMaterial, setCheckMaterial] = useState(false);
  const [checkUnit, setCheckUnit] = useState(false);

  const { refetch } = useQuery(SELECT_MATERIAL, {
    variables: {
      isUse: true,
      groupId: groupId,
      sectionId: null,
    },
    onCompleted: ({ selectMaterial }) => {
      // console.log("selectMaterial::", selectMaterial)
      //
      if (selectMaterial?.length > 0) {
        const materialData = selectMaterial?.map((e) => {
          return {
            id: e?._id,
            title: e?.materialKhName,
            // title: "ISBN: "+e?.isbm+" - "+e?.groupId?.groupKhName,
            fullName: e?.materialKhName,
            // +" "+e?.materialKhName,
          };
        });
        setMeterialOptions(materialData);
      } else {
        setMeterialOptions([]);
      }
    },
    onError: (error) => {
      // setLoading(true);
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [checkMaterial, groupId]);

  const { refetch: refetchUnit } = useQuery(SELECT_UNIT_BYID_MATERIAL, {
    variables: {
      materialId: materialId,
    },
    onCompleted: ({ selectUnitByMaterialId }) => {
      // console.log("selectUnitByMaterialId:::", selectUnitByMaterialId);
      if (selectUnitByMaterialId?.length > 0) {
        const unitData = selectUnitByMaterialId?.map((e) => {
          return {
            id: e?._id,
            title: e?.unitId?.unitKhName,
            imageSrc: e?.imageSrc,
          };
        });
        setUnitOptions(unitData);
      } else {
        setUnitOptions([]);
      }
    },
    onError: (error) => {
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetchUnit();
  }, [checkUnit, materialId]);

  return (
    <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
      <Stack
        direction="row"
        spacing={1}
        mb={1}
        bgcolor="#f5faff"
        paddingX="2px"
        paddingY="5px"
        borderRadius="8px"
      >
        <Typography className="field-title-list" sx={{ width: "10%" }}>
          រូបភាព
        </Typography>
        <Typography className="field-title-list" sx={{ width: "45%" }}>
          ឈ្មោះសម្ភារៈ
        </Typography>
        <Typography className="field-title-list" sx={{ width: "20%" }}>
          ឯកតា
        </Typography>
        <Typography className="field-title-list" sx={{ width: "15%" }}>
          ចំ.ផ្តល់
        </Typography>
        <Typography className="field-title-list" sx={{ width: "15%" }}>
          ចំ.លក់
        </Typography>
        <Typography className="field-title-list" sx={{ width: "15%" }}>
          ចំ.សរុប
        </Typography>
        <Stack width="5%" direction="column" justifyContent="center">
          <Box textAlign="center">
            <IconButton onClick={handleAddList}>
              <AddCircleIcon sx={{ color: "#2e3192" }} />
            </IconButton>
          </Box>
        </Stack>
      </Stack>
      {bookList?.map((e) => {
        // console.log("e::::", e);
        return (
          <Stack direction="column" spacing={-3} key={e?.key}>
            {/* <Stack direction="row" spacing={1} >
              <Stack width="8%"></Stack>
              <Stack direction="column" justifyContent="center">
                <Typography sx={{ height: "30px" , color: "#2e3192" , fontWeight: "bold" }}>
                  {e?.materialId?.fullName}
                </Typography>
              </Stack>
            </Stack> */}

            <Stack direction="row" spacing={1}>
              <Stack width="10%">
                <img
                  style={{
                    borderRadius: "10px",
                    objectFit: "cover",
                    width: "80%",
                  }}
                  src={
                    e?.listMaterialUnitId?.imageSrc
                      ? e?.listMaterialUnitId?.imageSrc
                      : EmptyImge
                  }
                />
              </Stack>
              <Stack width="45%" direction="column" justifyContent="center">
                <Autocomplete
                  value={e.materialId}
                  options={listMaterialOptions}
                  onChange={(event, val) => {
                    setCheckMaterial(true);
                    handleUpdateList(e.key, val, "materialId");
                    setMaterialId(val?.id);
                  }}
                  getOptionLabel={(option) =>
                    option?.title === undefined ? "ជ្រើសរើស" : option?.title
                  }
                  isOptionEqualToValue={(option, value) =>
                    option?.value === value?.value
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={"ជ្រើសរើស"}
                      error={
                        (requiredField && e?.materialId?.id === undefined) ||
                        (requiredField && e?.materialId?.id === "")
                          ? true
                          : false
                      }
                    />
                  )}
                />
              </Stack>
              <Stack width="20%" direction="column" justifyContent="center">
                <Autocomplete
                  value={e.listMaterialUnitId}
                  options={unitOptions}
                  onChange={(event, val) => {
                    setCheckUnit(true);
                    handleUpdateList(e.key, val, "listMaterialUnitId");
                  }}
                  getOptionLabel={(option) =>
                    option?.title === undefined ? "ជ្រើសរើស" : option?.title
                  }
                  isOptionEqualToValue={(option, value) =>
                    option?.value === value?.value
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={"ជ្រើសរើស"}
                      error={
                        (requiredField &&
                          e?.listMaterialUnitId?.id === undefined) ||
                        (requiredField && e?.listMaterialUnitId?.id === "")
                          ? true
                          : false
                      }
                    />
                  )}
                />
              </Stack>
              <Stack width="15%" direction="column" justifyContent="center">
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="បរិមាណ"
                  onFocus={(e) => e?.target?.select()}
                  value={e?.qty}
                  onChange={(val) =>
                    handleUpdateList(e.key, val.target.value, "qty")
                  }
                  // error={
                  //   (requiredField && e?.qty === 0) ||
                  //   (requiredField && e?.qty === "0") ||
                  //   (requiredField && e?.qty < 0)
                  // }
                  error={
                    (requiredField && e?.sellQty === 0 && e?.qty === 0) ||
                    (requiredField && e?.sellQty === "0" && e?.qty === "0") ||
                    (requiredField && e?.sellQty < 0 && e?.qty < 0)
                  }
                  inputProps={{
                    min: 0,
                  }}
                />
              </Stack>

              <Stack width="15%" direction="column" justifyContent="center">
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="បរិមាណ"
                  onFocus={(e) => e?.target?.select()}
                  value={e?.sellQty}
                  onChange={(val) =>
                    handleUpdateList(e.key, val.target.value, "sellQty")
                  }
                  // error={
                  //   (requiredField && e?.sellQty === 0) ||
                  //   (requiredField && e?.sellQty < 0)
                  // }
                  error={
                    (requiredField && e?.qty === 0 && e?.sellQty === 0) ||
                    (requiredField && e?.qty === "0" && e?.sellQty === "0") ||
                    (requiredField && e?.qty < 0 && e?.sellQty < 0)
                  }
                  inputProps={{
                    min: 0,
                  }}
                />
              </Stack>
              <Stack width="15%" direction="column" justifyContent="center">
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="បរិមាណសរុប"
                  value={parseFloat(e?.qty) + parseFloat(e?.sellQty)}
                />
              </Stack>

              <Stack width="5%" direction="column" justifyContent="center">
                <IconButton
                  sx={{ width: "40px", height: "40px" }}
                  onClick={() => handleDeleteList(e.key)}
                >
                  <RemoveCircleIcon sx={{ color: "red" }} />
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
}
